import Vue from 'vue';

// 获取导出列表
export const getExportList = (params) => Vue.axios.post('/cooperator/export/list', params);
